var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-page',{attrs:{"name":"login","wide":"","bg-color":"green","bg-image":"","padded":""}},[_c('login-box'),_c('register-hint')],1)}
var staticRenderFns = []

export { render, staticRenderFns }